import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import logoSvg from "@/assets/logo.svg";

const SHOP_DOMAIN = "oaria-2.myshopify.com";

const SUPPORT_LINKS = [
  { label: "Contact Us", href: "/pages/contact-us" },
  { label: "Shipping", href: "/pages/shipping" },
  { label: "Returns", href: "/pages/returns" },
  { label: "Track Your Order", href: "/pages/track-your-order" },
];

const LEGAL_LINKS = [
  { label: "Privacy Policy", href: "/pages/privacy-policy" },
  { label: "Terms of Service", href: "/pages/terms-of-service" },
  { label: "Your Privacy Choices", href: "/pages/data-sharing-opt-out" },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <Link to="/product/oaria-hyaluronic-acid-hydration-serum-1-fl-oz">
              <img src={logoSvg} alt="OARIA" className="h-14" style={{ aspectRatio: '784.5/711.75' }} width={62} height={56} />
            </Link>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-muted-foreground">
              Lightweight hydration for soft, smooth, comfortable skin.
            </p>
          </div>

          {/* Customer Support */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground">
              Support
            </h3>
            <ul className="mt-3 space-y-2">
              {SUPPORT_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground">
              Legal
            </h3>
            <ul className="mt-3 space-y-2">
              {LEGAL_LINKS.map((link) => (
                <li key={link.label}>
                  {"external" in link && link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Business info */}
        <div className="mt-10 border-t border-border pt-6 text-center sm:text-left">
          <p className="text-xs leading-relaxed text-muted-foreground">
            Axiome LLC · 30 North Gould Street Ste N, Sheridan, WY 82801, US
          </p>
        </div>

        {/* Payment methods */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-1.5 sm:justify-start">
          {["Visa", "Mastercard", "Amex", "Discover", "PayPal", "Apple Pay", "Google Pay", "Shop Pay"].map((method) => (
            <span
              key={method}
              className="inline-flex items-center rounded border border-border bg-background px-2 py-1 text-[10px] font-medium tracking-wide text-muted-foreground"
            >
              {method}
            </span>
          ))}
        </div>
        <Link
          to="/pages/returns"
          className="mt-3 inline-flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-foreground"
        >
          <ShieldCheck className="h-3.5 w-3.5" />
          <span className="text-[11px] font-medium">View the 60-Day Money-Back Guarantee</span>
        </Link>
        {/* Bottom bar */}
        <div className="mt-6 flex flex-col items-center gap-3 border-t border-border pt-6 text-center sm:flex-row sm:justify-between sm:text-left">
          <p className="text-xs text-muted-foreground">
            &copy; {year} OARIA. All rights reserved.
          </p>
          <a
            href="mailto:info@oariaskin.com"
            className="inline-flex items-center gap-1.5 text-xs text-muted-foreground transition-colors hover:text-foreground"
          >
            <Mail className="h-3.5 w-3.5" />
            info@oariaskin.com
          </a>
        </div>
      </div>
    </footer>
  );
}
